import type * as React from 'react';

import injectSheet, { type ClassNameMap } from 'react-jss';

import { KeyValue } from '@/components/ui/keyValue/keyValue';
import styles from './fileField.style';
import Item from './item';

interface Props {
  classes: ClassNameMap<string>;
  formData: any[];
  schema: {
    title: string;
  };
  uiSchema;
  formContext: {
    downloadFile: () => void;
    downloadAllFiles: () => void;
  };
  name: string;
}

export const FileField: React.FC<Props> = ({
  classes,
  formData,
  schema,
  formContext,
  uiSchema,
  name
}) => {
  const { downloadFile } = formContext || {};
  const options = uiSchema['ui:options'];

  if (!(formData?.length >= 1)) return null;

  return (
    <div className={classes.keyValueContainer}>
      <KeyValue
        dataCyName={name}
        title={options?.noLabel ? undefined : schema.title}
      >
        <ul className={classes.root}>
          {formData.map(file => (
            <li className={classes.file} key={file.name}>
              <Item downloadFile={downloadFile} file={file} />
            </li>
          ))}
        </ul>
      </KeyValue>
    </div>
  );
};

export default injectSheet(styles)(FileField);
